"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_ASSISTANT_CAMPAIGN_TYPES = exports.ORGANIZATION_ASSISTANT_PAGE_PAYOUT_ID = exports.ORGANIZATION_ASSISTANT_PAGE_PATH_MAX_LENGTH = exports.ORGANIZATION_ASSISTANT_PAGE_PATH = exports.ORGANIZATION_ASSISTANT_HANDOFF_TOPIC_LABELS = exports.ORGANIZATION_ASSISTANT_HANDOFF_TOPICS = exports.ORGANIZATION_ASSISTANT_DESTINATIONS = void 0;
const common_1 = require("../../enums/common");
const ticketing_1 = require("../../enums/ticketing");
exports.ORGANIZATION_ASSISTANT_DESTINATIONS = [
    "payouts",
    "payout_detail",
    "bank",
    "bank_settings",
    "create_bank_account",
    "stripe_onboarding",
    "identity_verification",
    "payments",
    "payment",
    "form_editor",
    "campaign_hub",
    "campaigns",
    "team",
    "invite_member",
    "tax_receipts",
    "organization_settings",
    "organization_information",
    "organization_page_editor",
    "communications",
    "contacts",
    "insights",
];
exports.ORGANIZATION_ASSISTANT_HANDOFF_TOPICS = [
    "payout_failed",
    "payout_delayed",
    "payout_schedule",
    "verification",
    "refund",
    "dispute",
    "bank_account",
    "account_recovery",
    "two_factor",
    "other",
];
exports.ORGANIZATION_ASSISTANT_HANDOFF_TOPIC_LABELS = {
    payout_failed: "Failed payout",
    payout_delayed: "Delayed payout",
    payout_schedule: "Payout schedule",
    verification: "Verification",
    refund: "Refund",
    dispute: "Dispute",
    bank_account: "Bank account",
    account_recovery: "Account recovery",
    two_factor: "Two-factor authentication",
    other: "Other",
};
exports.ORGANIZATION_ASSISTANT_PAGE_PATH = /^\/o(\/[a-z0-9-]+)*$/;
exports.ORGANIZATION_ASSISTANT_PAGE_PATH_MAX_LENGTH = 512;
exports.ORGANIZATION_ASSISTANT_PAGE_PAYOUT_ID = /^po_[A-Za-z0-9]{1,64}$/;
exports.ORGANIZATION_ASSISTANT_CAMPAIGN_TYPES = [
    common_1.DonationFormCategory.DonationForm,
    common_1.DonationFormCategory.PeerToPeerCampaign,
    ticketing_1.TicketingFormCategory.Event,
    ticketing_1.TicketingFormCategory.Lottery,
    ticketing_1.TicketingFormCategory.Auction,
    ticketing_1.TicketingFormCategory.MembershipV2,
    ticketing_1.TicketingFormCategory.Shop,
    "signUpForms",
];
